import { atomWithMutation } from 'jotai-tanstack-query';
import { IOpenDietitianAttachmentConsultationRequest } from '@/shared/interfaces';
import { R } from '@/Resources.resx';
import { createDietitianAttachmentConsultation } from '@/features/fileUpload/api/createDietitianAttachmentConsultation';

export const createDietitianAttachmentConsultationMutationAtom =
    atomWithMutation((get) => ({
        mutationFn: async (
            variables: IOpenDietitianAttachmentConsultationRequest,
        ): Promise<string> => {
            return createDietitianAttachmentConsultation(variables).catch(
                (error) => {
                    // Modify the error message but still throw it for React Query to handle
                    throw new Error(
                        `${R.CouldNotCreateDietitianAttachmentConsultation}`,
                    );
                },
            );
        },
    }));
